module.exports = __webpack_public_path__ + "assets/img/4ea2ad856c11c6a68bba8c822bfecc00.png";